export type BuiltinSelectorName = 'area-header' | 'area-footer' | 'editor-table-of-content--container';

export type HoveredTargetKind = 'class' | 'tag';

export interface HoveredTarget {
  slot: BuiltinSelectorName;
  kind: HoveredTargetKind;
  value: string;
}

export function buildHoverModifier(slot: BuiltinSelectorName, hovered: HoveredTarget | null | undefined): string {
  if (!hovered || hovered.slot !== slot) return '';
  return hovered.kind === 'tag' ? `dc-hover-tag-${hovered.value}` : `dc-hover-${hovered.value}`;
}

export interface BuiltinSelectorConfig {
  visibilityVar?: string;
}

export const BUILTIN_SELECTORS: Record<BuiltinSelectorName, BuiltinSelectorConfig> = {
  'area-header': { visibilityVar: '--xrpShowHeader' },
  'area-footer': { visibilityVar: '--xrpShowFooter' },
  'editor-table-of-content--container': {},
};

export const BUILTIN_SELECTOR_NAMES: readonly BuiltinSelectorName[] = ['area-header', 'area-footer', 'editor-table-of-content--container'];

export const ALSO_RESERVED: readonly string[] = ['subarea-headers', 'subarea-pagenumber', 'subarea-texts', 'page-content', 'toolbar', 'financial-toolbar'];

export function isBuiltinSelector(name: string): name is BuiltinSelectorName {
  return name in BUILTIN_SELECTORS;
}

export function isReservedSelector(name: string): boolean {
  return isBuiltinSelector(name) || ALSO_RESERVED.includes(name);
}

export function getVisibilityVar(name: BuiltinSelectorName): string | undefined {
  return BUILTIN_SELECTORS[name].visibilityVar;
}
